// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useQueryApi } from "api/hooks.ts";
import { conversionTypeApi, GetConversionTypeSelectResponse } from "api/TenantSlug/ConversionType/api.ts";

// Hook to get list of contacts
export const useGetSelectConversionTypesQuery = (request, options = {}) => {
    return useQueryApi<GetConversionTypeSelectResponse>({
        queryKey: ["getSelectConversionTypes", request],
        queryFn: () => conversionTypeApi.index(request),
        ...options,
    });
};
